import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { PHONE_OR_TOUCH_QUERY, useMediaQuery } from "../hooks/useMediaQuery";
import styles from "./Popover.module.css";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

/** On touch and on a phone, a popover keeps 8px (--space-2) from each screen edge. */
const TOUCH_COLLISION_PADDING = 8;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /** The element that holds the popover. The default is the body. */
    container?: HTMLElement | null;
  }
>(({ className, align = "center", sideOffset = 4, collisionPadding, container, ...props }, ref) => {
  const phoneOrTouch = useMediaQuery(PHONE_OR_TOUCH_QUERY);
  return (
    <PopoverPrimitive.PopoverPortal container={container}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={
          collisionPadding ?? (phoneOrTouch ? TOUCH_COLLISION_PADDING : undefined)
        }
        className={`${styles.content}${className ? ` ${className}` : ''}`}
        {...props}
      />
    </PopoverPrimitive.PopoverPortal>
  );
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
